import { useEffect, useState } from "react";
import { Play } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const ROUND = 45;

const makeQ = (age) => {
  const max = age < 7 ? 10 : age < 10 ? 20 : 50;
  let a = 1 + Math.floor(Math.random() * max);
  let b = 1 + Math.floor(Math.random() * max);
  const sub = age >= 7 && Math.random() < 0.4;
  if (sub && b > a) [a, b] = [b, a];
  const ans = sub ? a - b : a + b;
  const opts = new Set([ans]);
  while (opts.size < 3) opts.add(Math.max(0, ans + Math.floor(Math.random() * 7) - 3));
  return { text: `${a} ${sub ? "−" : "+"} ${b}`, ans, opts: [...opts].sort(() => Math.random() - 0.5) };
};
const BUBBLES = ["#FF8FC7", "#3DCCC7", "#FFD23F"];

export const MathPop = ({ onFinish }) => {
  const { kid } = useAuth();
  const [on, setOn] = useState(false);
  const [left, setLeft] = useState(ROUND);
  const [score, setScore] = useState(0);
  const [q, setQ] = useState(() => makeQ(kid.age));
  const [flash, setFlash] = useState(null);

  useEffect(() => {
    if (!on) return;
    if (left <= 0) { setOn(false); onFinish(score, score >= 15 ? 3 : score >= 10 ? 2 : score >= 5 ? 1 : 0); return; }
    const t = setTimeout(() => setLeft((l) => l - 1), 1000);
    return () => clearTimeout(t);
  }, [on, left, score, onFinish]);

  const pick = (o) => {
    const ok = o === q.ans;
    setFlash(ok ? "ok" : "no");
    if (ok) setScore((s) => s + 1);
    setQ(makeQ(kid.age));
    setTimeout(() => setFlash(null), 250);
  };

  if (!on && left === ROUND) {
    return (
      <div className="zn-card bg-[#B8F2C9] p-8 text-center max-w-md mx-auto">
        <p className="font-display text-2xl font-bold mb-2">Pop as many right answers as you can in {ROUND} seconds!</p>
        <button data-testid="math-start-btn" onClick={() => setOn(true)} className="zn-btn bg-[#FF6B4A] text-white mt-4"><Play size={18} /> Start</button>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto text-center">
      <div className="flex justify-between font-display text-lg mb-4"><span data-testid="math-score">Score: {score}</span><span data-testid="math-timer">{left}s</span></div>
      <div data-testid="math-question" className={`zn-card p-8 mb-6 font-display text-5xl font-bold transition-colors ${flash === "ok" ? "bg-[#B8F2C9]" : flash === "no" ? "bg-[#FFE4EC]" : "bg-white"}`}>{q.text} = ?</div>
      <div className="grid grid-cols-3 gap-3">
        {q.opts.map((o, i) => (
          <button key={`${q.text}-${o}`} data-testid={`math-option-${i}`} data-correct={o === q.ans} disabled={!on} onClick={() => pick(o)}
            className="aspect-square rounded-full border-[3px] border-[#1B1A2E] shadow-[4px_4px_0_0_#1B1A2E] font-display text-3xl font-bold active:scale-90 transition-transform zn-pop" style={{ background: BUBBLES[i] }}>{o}</button>
        ))}
      </div>
    </div>
  );
};
